import {
  RANK_MAPPING_LOADING,
  RANK_MAPPING_ERROR,
  SET_RANK_MAPPING_SETTINGS,
  SET_RANK_MAPPINGS,
  SET_RANK_MAPPING_PAGINATION
} from '../actions';

const initialState = {
  settings: {
    sheetId: '',
    sheetName: 'RankMapping',
    lastSyncAt: '',
    lastSyncStatus: '',
    lastSyncMessage: ''
  },
  mappings: [],
  loading: false,
  error: null,
  pagination: {
    current: 1,
    pageSize: 50,
    total: 0
  }
};

const rankMappingReducer = (state = initialState, action) => {
  switch (action.type) {
    case RANK_MAPPING_LOADING:
      return { ...state, loading: action.payload };
    case RANK_MAPPING_ERROR:
      return { ...state, error: action.payload, loading: false };
    case SET_RANK_MAPPING_SETTINGS:
      return { ...state, settings: { ...state.settings, ...action.payload }, error: null };
    case SET_RANK_MAPPINGS:
      return { ...state, mappings: action.payload, error: null };
    case SET_RANK_MAPPING_PAGINATION:
      return { ...state, pagination: { ...state.pagination, ...action.payload } };
    default:
      return state;
  }
};

export default rankMappingReducer;
